const RELOAD_KEY = 'chunk-reload-at';
const RELOAD_GUARD_MS = 10 * 1000;

let reloadPending = false;

const CHUNK_ERROR_PATTERNS = [
  /Failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /Importing a module script failed/i,
  /Unable to preload CSS/i,
];

export const isChunkLoadError = (error: unknown) =>
  error instanceof Error && CHUNK_ERROR_PATTERNS.some((pattern) => pattern.test(error.message));

export const reloadForNewVersion = () => {
  if (reloadPending) return true;
  try {
    const lastReload = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
    if (Date.now() - lastReload < RELOAD_GUARD_MS) return false;
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  } catch {
    return false;
  }
  reloadPending = true;
  window.location.reload();
  return true;
};
